'use client'

import * as React from 'react'
import { Tabs as TabsPrimitive } from 'radix-ui'

import { cn } from '@/lib/utils'

function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn('flex flex-col gap-2', className)}
      {...props}
    />
  )
}

function TabsList({
  className,
  variant = 'default',
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List> & { variant?: 'default' | 'bubble' }) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        'inline-flex h-9 items-center justify-center bg-transparent',
        variant === 'bubble' && 'h-auto justify-start gap-2 py-2!',
        className
      )}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  variant = 'default',
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger> & { variant?: 'default' | 'bubble' }) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        variant === 'bubble'
          ? 'text-foreground/60! hover:bg-foreground/10! hover:text-foreground! active:bg-foreground/20! data-[state=active]:bg-emphasis! data-[state=active]:text-emphasis-foreground! data-[state=active]:hover:bg-emphasis/85! data-[state=active]:active:bg-emphasis/70! inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-full! px-3! py-1.5! text-sm leading-5 font-medium whitespace-nowrap disabled:pointer-events-none disabled:opacity-50'
          : 'data-[state=active]:border-b-foreground inline-flex h-full min-w-[80px] flex-1 cursor-pointer items-center justify-center gap-1.5 border-b border-b-transparent px-2 py-3 font-sans text-sm font-medium whitespace-nowrap text-white transition-[color,border-color] duration-200 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-white data-[state=inactive]:text-white/40 data-[state=inactive]:hover:text-white/70 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        className
      )}
      {...props}
    />
  )
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn(
        'data-[state=active]:animate-in data-[state=active]:fade-in-0 data-[state=active]:slide-in-from-bottom-1 flex-1 duration-200 outline-none motion-reduce:animate-none',
        className
      )}
      {...props}
    />
  )
}

export { Tabs, TabsContent, TabsList, TabsTrigger }
